import axios from 'axios';
import { API_BASE_URL, createAuthHeader } from '../config/api.config';

const headers = () => ({ headers: createAuthHeader(localStorage.getItem('access_token')) });

/** Rules (laws + client's own) and form options. */
export const fetchCostRules = async (customerId) => {
  const response = await axios.get(`${API_BASE_URL}/cost-rules?clientId=${customerId}`, headers());
  return response.data;
};

export const createCostRule = async (customerId, rule) => {
  const response = await axios.post(`${API_BASE_URL}/cost-rules?clientId=${customerId}`, rule, headers());
  return response.data;
};

export const updateCostRule = async (customerId, id, rule) => {
  const response = await axios.put(`${API_BASE_URL}/cost-rules/${id}?clientId=${customerId}`, rule, headers());
  return response.data;
};

/** One or more experiments (a table row) before (the given baseline) and during, each cost by name and tag. */
export const fetchExperimentCostBreakdown = async (customerId, experimentIds, baseline) => {
  const response = await axios.post(
    `${API_BASE_URL}/experiments/cost-breakdown?clientId=${customerId}`,
    { experimentIds, baseline },
    headers()
  );
  return response.data;
};

/** Adds and removes tax tags on several products at once; an added tag replaces the one of its tax. */
export const changeProductTaxTags = async (customerId, productIds, add, remove) => {
  const response = await axios.put(
    `${API_BASE_URL}/cost-rules/products/tags?clientId=${customerId}`, { productIds, add, remove }, headers()
  );
  return response.data;
};

/** Sets the tax tags of one product (d_product.tax_tags). */
export const setProductTaxTags = async (customerId, productId, tags) => {
  const response = await axios.put(`${API_BASE_URL}/cost-rules/products/${productId}/tags?clientId=${customerId}`, { tags }, headers());
  return response.data;
};
